import { Contents } from "#/components/Contents/Contents";
import { usePositionsDrawerRfqTab } from "#/store/app/positionsDrawer/positionsDrawerRfqTab";

import { RfqResponses } from "./components/RfqResponses/RfqResponses";

export const Rfq: React.FC = () => {
  const { positionsDrawerRfqTab } = usePositionsDrawerRfqTab();

  return (
    <Contents isEmpty={false} animateKey={positionsDrawerRfqTab}>
      <RfqResponses />
    </Contents>
  );
};
